// Show/enable the image-description fields only while an image is present.
//
// Markup contract (see calendarapp/dashboard/event_form.html):
//   <div data-image-fields
//        data-image-file="tmp_image"                  file input name
//        data-image-clear="tmp_image-clear"           optional clear checkbox name
//        data-image-targets="desc_sl,desc_en"         comma-separated field names
//        data-has-image="true|false">                 image present on load
//
// An image is considered present when the file input has a chosen file, a
// cached upload was restored (after a failed submit), or the element loaded
// with an existing image and the clear checkbox is not ticked.
function initContainer(container) {
  const fileName = container.dataset.imageFile;
  const clearName = container.dataset.imageClear;
  const targetNames = (container.dataset.imageTargets || "")
    .split(",")
    .map((n) => n.trim())
    .filter(Boolean);
  if (!targetNames.length) {
    return;
  }

  const baseHasImage = container.dataset.hasImage === "true";
  const fileInput = fileName
    ? container.querySelector(`[name='${fileName}']`)
    : null;
  const clearInput = clearName
    ? container.querySelector(`[name='${clearName}']`)
    : null;
  const cachedInput = container.querySelector("[data-image-cached]");
  const targets = targetNames
    .map((n) => container.querySelector(`[name='${n}']`))
    .filter(Boolean);

  function hasImage() {
    if (fileInput && fileInput.files && fileInput.files.length > 0) {
      return true;
    }
    if (clearInput && clearInput.checked) {
      return false;
    }
    if (cachedInput) {
      return true;
    }
    return baseHasImage;
  }

  function toggle() {
    const show = hasImage();
    targets.forEach((field) => {
      const wrapper = field.closest(".form-group");
      if (wrapper) {
        wrapper.hidden = !show;
      }
      field.disabled = !show;
    });
  }

  if (fileInput) {
    fileInput.addEventListener("change", toggle);
  }
  if (clearInput) {
    clearInput.addEventListener("change", toggle);
  }
  toggle();
}

export default function initImageFieldToggle(target) {
  target.querySelectorAll("[data-image-fields]").forEach(initContainer);
}
